import { Button } from "@mui/material"
import { store } from "../../../stores/Store"
import { DisplayValue } from "../../.."
import { observer } from "mobx-react-lite"
import Field from "../../form/fields/Field"
import { Icons } from "../../../misc/Icons"
import InlineMenu from "../../../misc/InlineMenu"
import { Theme } from "../../../misc/Theme"

export const ColumnHeaderAccount = ({label}) => {

    var clientOptions = store.QuestionnaireStore.advisorOptions
    var filteringApplied = store.QuestionnaireStore.searchAccountUids?.length < clientOptions?.length

    return (
        <InlineMenu 
            closeOnClick={false} 
            opener={(
                <div style={{display: "flex", alignItems: "center", gap: "4px"}}>
                    <Button 
                        className="btn btn-lowercase" 
                        color="info">
                        {label}
                        {filteringApplied ? (
                            <span style={{height: "16px", lineHeight: "16px", fontSize: "10px", color: "white", backgroundColor: Theme.palette.error.main, padding: "0px 6px", borderRadius: "12px", fontWeight: 600}}>
                                {store.QuestionnaireStore.searchAccountUids?.length}
                            </span>
                        ) : null}
                    </Button>
                    <Icons.ChevronLeft style={{fontSize: "18px", transform: "rotateZ(-90deg)"}} />
                </div>
            )}>
            <ColumnHeaderAccountField />
        </InlineMenu>
    )
}

const ColumnHeaderAccountField = observer(() => {

    const { searchAccountUids, setSearchAccountUids, advisorOptions } = store.QuestionnaireStore

    return (
        <div style={{padding: "10px", width: "300px"}}>
            <div className="form">
                <h3>Filter by Sponsor</h3>
    
                <div style={{display: "grid", gap: "8px", maxHeight: "300px", overflowY: "auto", borderTop: "0.5px solid lightgrey", boxShadow: "#00000059 0px 14px 24px -16px inset", padding: "5px 0 0 5px"}}>
                    <Field.CheckboxSelect
                        formik 
                        value={searchAccountUids}
                        options={advisorOptions}
                        warning={false}
                        onChange={(e) => setSearchAccountUids(e.target.value)} />
                </div>

                <div style={{display: "flex", gap: "5px"}}>
                    <Button className="btn btn-sm" variant="contained" onClick={() => store.QuestionnaireStore.setSearchAccountUids([])}>Clear selection</Button>
                    <Button className="btn btn-sm" variant="contained" onClick={() => store.QuestionnaireStore.setSearchAccountUids(null)}>Select all</Button>
                </div>
            </div>
        </div>
    )
})

export const ColumnHeaderTemplate = () => {

    var filteringApplied = store.QuestionnaireStore.searchTemplateKeys?.length < store.QuestionnaireStore.templateKeyOptions?.length

    return (
        <InlineMenu 
            closeOnClick={false} 
            opener={(
                <div style={{display: "flex", alignItems: "center", gap: "4px"}}>
                    <Button 
                        className="btn btn-lowercase" 
                        color="info">
                        Questionnaire type 
                        {filteringApplied ? (
                            <span style={{height: "16px", lineHeight: "16px", fontSize: "10px", color: "white", backgroundColor: Theme.palette.error.main, padding: "0px 6px", borderRadius: "12px", fontWeight: 600}}>
                                {store.QuestionnaireStore.searchTemplateKeys?.length}
                            </span>
                        ) : null}
                    </Button>

                    <Icons.ChevronLeft style={{fontSize: "18px", transform: "rotateZ(-90deg)"}} />
                </div>
            )}>
            <ColumnHeaderTemplateSelect />
        </InlineMenu>
    )
}

const ColumnHeaderTemplateSelect = observer(() => {

    const { searchTemplateKeys, setSearchTemplateKeys, templateKeyOptions } = store.QuestionnaireStore

    return (
        <div style={{padding: "10px", width: "300px"}}>
            <div className="form">
                <h3>Filter by Questionnaire type</h3>
                    
                <div style={{display: "grid", gap: "8px", maxHeight: "300px", overflowY: "auto", borderTop: "0.5px solid lightgrey", boxShadow: "#00000059 0px 14px 24px -16px inset", padding: "5px 0 0 5px"}}>
                    {templateKeyOptions.map((option, i) => {
                        var selected = searchTemplateKeys.includes(option.value)
                        return (
                            <Field.Checkbox 
                                formik
                                label={option.label} 
                                value={selected}
                                warning={false}
                                onChange={(e) => {
                                    var newKeys = selected
                                        ? searchTemplateKeys.filter(key => key !== option.value)
                                        : [...searchTemplateKeys, option.value]
    
                                    setSearchTemplateKeys(newKeys)
                                }} />
                        )
                    })}
                </div>

                <div style={{display: "flex", gap: "5px"}}>
                    <Button className="btn btn-sm" variant="contained" onClick={() => store.QuestionnaireStore.setSearchTemplateKeys([])}>Clear selection</Button>
                    <Button className="btn btn-sm" variant="contained" onClick={() => store.QuestionnaireStore.setSearchTemplateKeys(null)}>Select all</Button>
                </div>
            </div>
        </div>
    )
})

export const ColumnHeaderNotificationEmail = () => {
    
    var filteringApplied = store.QuestionnaireStore.searchNotificationEmails?.length < store.QuestionnaireStore.notificationEmailOptions?.length

    return (
        <InlineMenu 
            closeOnClick={false} 
            opener={(
                <div style={{display: "flex", alignItems: "center", gap: "4px"}}>
                    <Button className="btn btn-lowercase" color="info">
                        Advisor email 
                        {filteringApplied ? (
                            <span style={{height: "16px", lineHeight: "16px", fontSize: "10px", color: "white", backgroundColor: Theme.palette.error.main, padding: "0px 6px", borderRadius: "12px", fontWeight: 600}}>
                                {store.QuestionnaireStore.searchNotificationEmails?.length}
                            </span>
                        ) : null}
                    </Button>
                    <Icons.ChevronLeft style={{fontSize: "18px", transform: "rotateZ(-90deg)"}} />
                </div>
            )}>
            <ColumnHeaderNotificationEmailField />
        </InlineMenu>
    )
}

const ColumnHeaderNotificationEmailField = observer(() => {

    const { notificationEmailOptions, searchNotificationEmails, setSearchNotificationEmails } = store.QuestionnaireStore

    return (
        <div style={{padding: "10px", width: "300px"}}>
            <div className="form">
                <h3>Filter by adviser email</h3>
    
                <div style={{display: "grid", gap: "8px", maxHeight: "300px", overflowY: "auto", borderTop: "0.5px solid lightgrey", boxShadow: "#00000059 0px 14px 24px -16px inset", padding: "5px 0 0 5px"}}>
                    <Field.CheckboxSelect
                        formik 
                        value={searchNotificationEmails}
                        options={notificationEmailOptions}
                        warning={false}
                        onChange={(e) => setSearchNotificationEmails(e.target.value)} />
                </div>

                <div style={{display: "flex", gap: "5px"}}>
                    <Button className="btn btn-sm" variant="contained" onClick={() => setSearchNotificationEmails([])}>Clear selection</Button>
                    <Button className="btn btn-sm" variant="contained" onClick={() => setSearchNotificationEmails(null)}>Select all</Button>
                </div>
            </div>
        </div>
    )
})


export function ColumnHeader ({value}) {

    const {order, orderedBy, setOrder, setOrderedBy} = store.QuestionnaireStore

    return (
        <div>
            <Button className="btn btn-lowercase" color="info" onClick={() => {
                if (orderedBy !== value) {
                    setOrderedBy(value)
                } else {
                    setOrder(order === "asc" ? "desc" : "asc")
                }
            }}>
                {DisplayValue("dict_key", value)}

                {/* {orderedBy === value ? (
                    <>
                        {order === "asc" ? <Icons.ArrowUp style={{fontSize: "12px"}} /> : <Icons.ArrowDown style={{fontSize: "12px"}} />}
                    </>
                ) : null} */}
            </Button>
        </div>
    )
}